import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { GiftIcon, BookIcon } from 'lucide-react';
export function BonusStackSection() {
  const bonuses = [{
    num: '01',
    emoji: '🎧',
    title: 'Audio de Relajación Guiada',
    desc: 'Audio de relajación progresiva para escuchar en la cama. Voz calmante que guía tu cuerpo al sueño profundo en minutos. Úsalo cada noche como parte de tu protocolo.',
    value: '$17'
  }, {
    num: '02',
    emoji: '🎙️',
    title: 'Podcast Explicativo: La Respiración 4-7-8',
    desc: 'Diálogo entre dos expertos explicando paso a paso la técnica de respiración más poderosa para apagar tu sistema nervioso en 2 minutos. Perfecto para entender el método antes de aplicarlo.',
    value: '$17'
  }, {
    num: '03',
    emoji: '✨',
    title: 'Guía Visual de Relajación',
    desc: '15 páginas visuales diseñadas para acompañar tu audio de relajación. Imágenes y frases calmantes en diseño oscuro y elegante.',
    value: '$17'
  }];
  return <section id="bonos" className="py-20 md:py-24 bg-[#0d1530] border-t border-cyan-400/15 scroll-mt-8" data-id="element-97">
      <div className="max-w-5xl mx-auto px-6" data-id="element-98">
        <FadeIn data-id="element-99">
          <div className="text-center mb-14" data-id="element-100">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full card-glass mb-6" data-id="element-101">
              <GiftIcon className="w-4 h-4 text-gold-400" data-id="element-102" />
              <span className="text-sm uppercase tracking-widest text-gold-400 font-medium" data-id="element-103">
                Bonos Incluidos
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-serif mb-4 text-glow" data-id="element-104">
              Más 3 bonos para que duermas mejor desde la primera noche
            </h2>
            <p className="text-cream-muted text-body-lg max-w-2xl mx-auto" data-id="element-105">
              Todo lo que necesitas para construir tus mejores noches, sin
              esfuerzo.
            </p>
          </div>
        </FadeIn>

        {/* Bonus cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-106">
          {bonuses.map((b, i) => <FadeIn key={i} delay={0.1 + i * 0.1} data-id="element-107">
              <article className="card-glass rounded-md p-7 h-full flex flex-col" data-id="element-108">
                <div className="flex items-center justify-between mb-5" data-id="element-109">
                  <span className="text-sm font-medium tracking-widest text-gold-400" data-id="element-110">
                    BONO #{b.num}
                  </span>
                  <span className="text-3xl leading-none" aria-hidden="true" data-id="element-111">
                    {b.emoji}
                  </span>
                </div>
                <h3 className="text-xl font-serif text-white mb-3 leading-snug" data-id="element-112">
                  {b.title}
                </h3>
                <p className="text-cream-muted text-base mb-6 flex-grow" data-id="element-113">
                  {b.desc}
                </p>
                <div className="pt-5 border-t border-cyan-400/20 flex items-center justify-between" data-id="element-114">
                  <span className="text-sm text-cream-muted line-through decoration-gold-500/40" data-id="element-115">
                    Valor: {b.value}
                  </span>
                  <span className="text-gold-400 font-medium text-sm uppercase tracking-wider" data-id="element-116">
                    GRATIS
                  </span>
                </div>
              </article>
            </FadeIn>)}
        </div>

        {/* Value breakdown */}
        <FadeIn delay={0.4} data-id="element-117">
          <div className="card-glass-strong rounded-md p-8 md:p-10 max-w-2xl mx-auto" data-id="element-118">
            <h3 className="text-lg font-serif text-center text-white mb-6 uppercase tracking-widest" data-id="element-119">
              Resumen del paquete
            </h3>

            <ul className="space-y-3 mb-7" data-id="element-120">
              <ValueRow icon="🎧" label="Audio de Relajación Guiada" value="$17" data-id="element-121" />
              <ValueRow icon="🎙️" label="Podcast Respiración 4-7-8" value="$17" data-id="element-122" />
              <ValueRow icon="✨" label="Guía Visual de Relajación" value="$17" data-id="element-123" />
              <ValueRow icon={<BookIcon className="w-5 h-5 text-gold-500" data-id="element-125" />} label="Guía Principal Sueño Profundo 50+" value="$46" data-id="element-124" />
            </ul>

            <div className="pt-5 border-t border-cyan-400/25 flex items-center justify-between mb-7" data-id="element-126">
              <span className="text-cream-muted uppercase text-sm tracking-wider" data-id="element-127">
                Valor Total
              </span>
              <span className="text-2xl md:text-3xl font-serif text-cream-muted line-through decoration-gold-500/60" data-id="element-128">
                $97 USD
              </span>
            </div>

            <div className="flex items-center justify-between" data-id="element-129">
              <span className="text-gold-400 uppercase text-sm tracking-wider font-medium" data-id="element-130">
                Hoy solo
              </span>
              <span className="text-4xl md:text-5xl font-serif text-gold-400" data-id="element-131">
                $17 USD
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-132">
          <div id="quiero-bonos" className="mt-12 text-center scroll-mt-[60vh] md:scroll-mt-[55vh]" data-id="element-133">
            <Button href="#oferta" className="px-10 py-5 text-lg" data-id="element-134">
              Quiero Mis Bonos Ahora
            </Button>
            <p className="mt-4 text-sm text-cream-muted" data-id="element-135">
              Reserva tu acceso y todos los bonos al precio de lanzamiento.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}
function ValueRow({
  icon,
  label,
  value
}: {
  icon: React.ReactNode;
  label: string;
  value: string;
}) {
  return <li className="flex items-center justify-between gap-4 text-base" data-id="element-136">
      <div className="flex items-center gap-3 min-w-0" data-id="element-137">
        <span className="text-xl flex-shrink-0" aria-hidden="true" data-id="element-138">
          {icon}
        </span>
        <span className="text-white truncate" data-id="element-139">{label}</span>
      </div>
      <span className="text-gold-400 font-medium flex-shrink-0" data-id="element-140">{value}</span>
    </li>;
}